<template>
  <div class="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full">
    <Icon name="general.chatInfo" size="base" />
  </div>
  <p>Embed option is available only to Signed in users</p>
  <Button type="solid" variant="orange" @click.stop.prevent="signUpClick()" icon="general.stars" data-testid="button-signup">Get Zight for Free</Button>
  <Button type="link" variant="black" @click.stop.prevent="signInClick()" icon="general.signIn" data-testid="button-signin">Sign In</Button>
</template>

<script setup lang="ts">
import { Icon } from '@/storybook/icon';
import { Button } from '@/storybook/button';

import { useAuthModals } from '@/composables/useAuthModals';
import { TrackEvents, useTrack } from '@/composables/useTrack';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const viewerItemStore = useViewerItemStore();

const { showSignInModal, showSignUpModal } = useAuthModals();
const { track } = useTrack();

const signInClick = () => {
  showSignInModal();
  track(TrackEvents.SIGN_IN_CLICK, { viewer: 'copernicus', hashid: viewerItemStore.id });
};

const signUpClick = () => {
  showSignUpModal();
  track(TrackEvents.SIGN_UP_CLICK, { viewer: 'copernicus', hashid: viewerItemStore.id });
};
</script>
